import styled from 'styled-components'

import { colors } from '@styles/vars/colors.style'
import { mq } from '@styles/vars/media-queries.style'

export const MissionInfoMain = styled.section`
  position: relative;
  overflow: hidden;
  background-color: ${colors.charcoal};
  color: ${colors.white};
`

export const MissionInfoContent = styled.div`
  position: relative;
`

export const MissionInfoLine = styled.div`
  display: none;

  ${mq.tabletL} {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 50%;
    z-index: 2;
    display: block;
    width: 0.2rem;
    background-color: ${colors.white};
    transform: translateX(-50%);
    pointer-events: none;
    will-change: transform;
  }
`

export const MissionInfoList = styled.ul`
  display: grid;
  grid-template-columns: 1fr;
  margin: 0;
  padding: 0;
  list-style: none;

  ${mq.tabletL} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
`

export const MissionInfoItem = styled.li`
  position: relative;
  min-width: 0;
  display: flex;
  align-items: flex-start;
  margin: 0;
  padding: clamp(5rem, 9vw, 9rem) 0;
  border-bottom: 0.1rem solid ${colors.white};

  &:last-child {
    border-bottom: 0;
  }

  ${mq.tabletL} {
    min-height: 50vh;
    margin-top: var(--top-margin);
    padding:100px ${({ $isLeft }) =>
      $isLeft ? '80px' : '0'} 100px ${({ $isLeft }) =>
      $isLeft ? '0' : '80px'};
    border-bottom: 0;
    justify-content: ${({ $isLeft }) =>
      $isLeft ? 'flex-end' : 'flex-start'};
    text-align: ${({ $isLeft }) => ($isLeft ? 'right' : 'left')};

    ${({ $isLeft }) =>
      $isLeft
        ? `
          grid-column: 1;
        `
        : `
          grid-column: 2;
        `}
  }
`

export const MissionInfoItemContent = styled.div`
  width: 100%;
  color: ${colors.white};
  font-size: clamp(3.4rem, 5.2vw, 7.4rem);
  font-weight: 400;

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    color: inherit;
    font: inherit;
  }

  p + p {
    margin-top: 0.8em;
  }

  strong {
    color: ${colors.pastelGreen};
    font-weight: 700;
  }

  em {
    font-style: italic;
  }

  ul,
  ol {
    margin: 1em 0 0;
    padding-left: 1.2em;
  }

  li + li {
    margin-top: 0.4em;
  }

  a {
    color: ${colors.pastelGreen};
    text-decoration: underline;
    text-decoration-thickness: 0.08em;
    text-underline-offset: 0.12em;
  }

  ${mq.tabletL} {
    font-size: clamp(4rem, 3.6vw, 6.5rem);
  }
`